/**
 * Reason codes for per-item quote notification failures.
 * Extend as backend error types are defined.
 */
export enum QuoteNotificationItemErrorReasonEnum {
  itemNotFound = 'itemNotFound',
  iqProcessingError = 'iqProcessingError',
  unknownError = 'unknownError',
}

/**
 * Action options available on a failed quote notification.
 * Extend as retry / remediations are implemented.
 */
export enum QuoteNotificationFailureActionEnum {
  viewError = 'viewError',
}

/**
 * Item-level error payload on failed quote notifications.
 */
export interface IQuoteNotificationItemError {
  desc: string;
  reason: QuoteNotificationItemErrorReasonEnum | string;
  error?: number;
}

/**
 * Resolved failing item row for quote notification UI display.
 */
export interface IQuoteNotificationItemErrorEntry {
  desc: string;
  guidance: string;
  reason: QuoteNotificationItemErrorReasonEnum | string;
  stockCode: string;
}

/**
 * Grouped user guidance for quote items sharing the same reason.
 */
export interface IQuoteNotificationItemErrorGuidance {
  guidance: string;
  reason: QuoteNotificationItemErrorReasonEnum | string;
}

/**
 * Available failure action for the quote notification panel.
 */
export interface IQuoteNotificationFailureAction {
  action: QuoteNotificationFailureActionEnum;
  label: string;
}
